var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.SceneManager = function(width, height, nogl, centerOrigin) {
    var rendererView = arguments.length <= 4 || typeof arguments[4] === "undefined" ? document.getElementById("game-canvas") : arguments[4];
    var _stage = new EHDI.aka.Container();
    var rendererOptions = {
        view: rendererView,
        antialiasing: false,
        transparent: true,
        resolution: window.devicePixelRatio,
        autoResize: true,
    }
	var _renderer;

	if(!!nogl){
		_renderer = new EHDI.aka.CanvasRenderer(width, height, rendererOptions);
	}else{
		_renderer = new EHDI.aka.AutoDetectRenderer(width, height, rendererOptions);
	}

    var _stageWidth = width;
    var _stageHeight = height;

    var _sceneList = [];
	  var _popUpList = [];
    var _currentScene = null;

    var _sceneLayer = new EHDI.aka.Container();
    var _popupLayer = new EHDI.aka.Container();
    var _notificationLayer = new EHDI.aka.Container();

    EHDI.screen = EHDI.screen || Object.create(null);
    EHDI.screen.stageWidth = width;
    EHDI.screen.stageHeight = height;
    EHDI.screen.centerOrigin = centerOrigin;
    if(centerOrigin) {
        _sceneLayer.position.set(width * 0.5, height * 0.5);
        _popupLayer.position.set(width * 0.5, height * 0.5);
        _notificationLayer.position.set(width * 0.5, height * 0.5);
    }

    _stage.addChild(_sceneLayer);
    _stage.addChild(_popupLayer);
    _stage.addChild(_notificationLayer);

    return {
        //GETTERS
        getStage : function () {
            return _stage;
        },
        getRenderer : function () {
            return _renderer;
        },
        getStageWidth : function () {
            return _stageWidth;
        },
        getStageHeight : function () {
            return _stageHeight;
        },
        defaultWidth : width,
        defaultHeight : height,

        renderScreen : function(){
          _renderer.render(_stage);
        },

        changeScene : function(scene, transition, destroyPrevious) {

            if(typeof scene.screenWillAppear === 'function') scene.screenWillAppear();
            if(_currentScene)
                if(typeof _currentScene.screenWillDisappear === 'function') _currentScene.screenWillDisappear();
            if(transition) {
				var values = Object.create(null);
                EHDI.config.isTransition = true;

				var keys = Object.keys(transition)
                for(var i = 0; i< keys.length; i++){
                  if(transition[keys[i]].hasOwnProperty('from') &&
                     transition[keys[i]].hasOwnProperty('to')){

						scene[keys[i]] = transition[keys[i]].from;
						values[keys[i]] = transition[keys[i]].to;

                  }else if(!transition[keys[i]].hasOwnProperty('duration')){

					values[keys[i]] = transition[keys[i]];

                  }
                }

                _sceneLayer.addChild(scene);

                values.onComplete = function() {
                    EHDI.config.isTransition = false;
                    if(_currentScene) {
                        if(typeof _currentScene.screenDidDisappear === 'function') _currentScene.screenDidDisappear();
                        _sceneLayer.removeChild(_currentScene);
                    }
                    if(typeof scene.screenDidAppear === 'function') scene.screenDidAppear();
                    if(destroyPrevious)
                        _currentScene.destroy({children : true});
                    _currentScene = scene;
                }

                TweenLite.to(scene, transition.duration, values);
            } else {
                _sceneLayer.addChild(scene);
                if(_currentScene) {
                    _sceneLayer.removeChild(_currentScene);
                    if(typeof _currentScene.screenDidDisappear === 'function') _currentScene.screenDidDisappear();
                }
                if(typeof scene.screenDidAppear === 'function') scene.screenDidAppear();
                if(destroyPrevious)
                    _currentScene.destroy({children : true});
                _currentScene = scene;
            }
        },

		/**
		 * @desc CurrentScene popup functions will work when first popup is added, succeeding popup won't call the function.
		 */
        pushPopUp : function(popup, transition) {
            if(typeof popup.popUpWillAppear === 'function') popup.popUpWillAppear();
            if(typeof _currentScene.popUpWillAppear === 'function' && _popUpList.length === 0) _currentScene.popUpWillAppear();
            if(transition) {
                var values = Object.create(null);
                EHDI.config.isTransition = true;

				var keys = Object.keys(transition)
                for(var i = 0; i< keys.length; i++){
                  if(transition[keys[i]].hasOwnProperty('from') &&
                     transition[keys[i]].hasOwnProperty('to')){

						popup[keys[i]] = transition[keys[i]].from;
						values[keys[i]] = transition[keys[i]].to;

                  }else if(!transition[keys[i]].hasOwnProperty('duration')){

					values[keys[i]] = transition[keys[i]];

                  }
                }

                _popupLayer.addChild(popup);

                values.onComplete = function() {
                    EHDI.config.isTransition = false;
                    if(typeof popup.popUpDidAppear === 'function') popup.popUpDidAppear();
                    if(typeof _currentScene.popUpDidAppear === 'function' && _popUpList.length === 0) _currentScene.popUpDidAppear();
                    _popUpList.push(popup);
                }

                TweenLite.to(popup, transition.duration, values);
            } else {
                _popUpList.push(popup);
                _popupLayer.addChild(popup);
                if(typeof popup.popUpDidAppear === 'function') popup.popUpDidAppear();
            }

        },

		/**
		 * @desc CurrentScene popPopUp function will be called when last popup is removed.
		 */
        popPopUp : function(transition, destroyPrevious) {
            if(_popUpList.length <= 0)
                throw "Pop Up list is empty!";

            var popUpToRemove = _popUpList.pop();
            if(typeof popUpToRemove.popUpWillDisappear === 'function') popUpToRemove.popUpWillDisappear();
            if(typeof _currentScene.popUpWillDisappear === 'function' && _popUpList.length === 0) _currentScene.popUpWillDisappear();

            if(transition) {
                var values = Object.create(null);
                EHDI.config.isTransition = true;

				var keys = Object.keys(transition)
                for(var i = 0; i< keys.length; i++){
                  if(transition[keys[i]].hasOwnProperty('from') &&
                     transition[keys[i]].hasOwnProperty('to')){

						popUpToRemove[keys[i]] = transition[keys[i]].from;
						values[keys[i]] = transition[keys[i]].to;

                  }else if(!transition[keys[i]].hasOwnProperty('duration')){

					values[keys[i]] = transition[keys[i]];

                  }
                }

                values.onComplete = function() {
                    EHDI.config.isTransition = false;
                    if(typeof popUpToRemove.popUpDidDisappear === 'function') popUpToRemove.popUpDidDisappear();
                    if(typeof _currentScene.popUpDidDisappear === 'function' && _popUpList.length === 0) _currentScene.popUpDidDisappear();
                    _popupLayer.removeChild(popUpToRemove);
                    if(destroyPrevious)
                        popUpToRemove.destroy({children : true});
                }

                TweenLite.to(popUpToRemove, transition.duration, values);
            }else {
                _popupLayer.removeChild(popUpToRemove);
                 if(typeof popUpToRemove.popUpDidDisappear === 'function') popUpToRemove.popUpDidDisappear();
                 if(typeof _currentScene.popUpDidDisappear === 'function' && _popUpList.length === 0) _currentScene.popUpDidDisappear();
                if(destroyPrevious)
                    popUpToRemove.destroy({children : true});
            }
        },

		popAllPopUps: function(destroyPrevious){
			while(_popUpList.length > 0){
				var popup = _popUpList.pop();
				if(typeof popup.popUpWillDisappear === 'function') popup.popUpWillDisappear();
				if(typeof _currentScene.popUpWillDisappear === 'function' && _popUpList.length === 0) _currentScene.popUpWillDisappear();

				_popupLayer.removeChild(popup);
				 if(typeof popup.popUpDidDisappear === 'function') popup.popUpDidDisappear();
                 if(typeof _currentScene.popUpDidDisappear === 'function' && _popUpList.length === 0) _currentScene.popUpDidDisappear();
                if(destroyPrevious)
                    popup.destroy({children : true});
			}
		},

        addNotification: function(notif){
          _notificationLayer.addChild(notif);
        },

		/**
		 * @param (OBJECT) notif - notification object
		 * @param (BOOLEAN) destroy - set to true to destroy object
		 */
        removeNotification: function(notif, destroy){
            var obj, index = _notificationLayer.children.indexOf(notif);
            if(index > -1){
				obj = _notificationLayer.removeChild(notif);
			}
			if(destroy) obj.destroy({children : true});
			obj = null;
        },

		/**
		 * @desc returns the topmost object from the notification layer
		 * @return (DisplayObject)
		 */
		popNofication: function(){
			return _notificationLayer.children.pop()
		},

        screenResize: function() {
            if(_currentScene && typeof _currentScene.onScreenResize === 'function') _currentScene.onScreenResize();
            _popUpList.forEach(function(element) {
                if(typeof element.onScreenResize === 'function') element.onScreenResize();
            });
            _notificationLayer.children.forEach(function(element) {
                if(typeof element.onScreenResize === 'function') element.onScreenResize();
            });
        }
    }
};

EHDI.scene.TransitionParameter  = function (from, to) {
    this.from = from;
    this.to = to;
}

EHDI.scene.TransitionParameter.constructor = EHDI.scene.TransitionParameter;
